import { render, staticRenderFns } from "./common-icon.vue?vue&type=template&id=b7b043de"
import script from "./common-icon.vue?vue&type=script&lang=js"
export * from "./common-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports